export default "__VITE_ASSET__BrnSv4qv__"